import { FC } from 'react'

import { Orb } from '../types'
import { WhiteOrbImage } from './white-orb-image'

export const WhiteOrb: FC<Orb> = ({ onClick, className }) => {
  return (
    <svg
      width="100"
      height="100"
      x="90"
      y="90"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <g filter="url(#filter0_dd_54_929)">
        <rect x="3.95068" y="1" width="19" height="19" fill="url(#white-orb)" shapeRendering="crispEdges" />
      </g>
      <defs>
        <filter
          id="filter0_dd_54_929"
          x="0.950684"
          y="0"
          width="25"
          height="25"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_54_929" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="effect1_dropShadow_54_929" result="effect2_dropShadow_54_929" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_54_929" result="shape" />
        </filter>
        <pattern id="white-orb" patternContentUnits="objectBoundingBox" width="1" height="1">
          <use href="#WhiteOrbImage" transform="scale(0.00166667)" />
        </pattern>
        <WhiteOrbImage />
      </defs>
    </svg>
  )
}
